import { createValidity, assertString } from '@mhub/web-validations';

export default function required(value, opts) {
  assertString(value);
  const options = Object.assign({}, opts);
  let { key, label, message, validRegex } = options;
  if (key === undefined) {
    key = 'key';
  }
  if (label === undefined) {
    label = 'Field';
  }
  if (message === undefined) {
    message = `${label} is not a valid phone number`;
  }
  if (validRegex === undefined) {
    validRegex = '^\\d+$';
  }
  const e = new RegExp(validRegex, 'i');
  const validity = createValidity(key);
  if (value !== '' && !e.test(value)) {
    validity.isValid = false;
    validity.message = message;
  }
  return validity;
}

export function getPhoneValidRegex(presets, prefix, type) {
  let regex = '^[0-9]*$';
  if (prefix && presets) {
    const preset = presets.find(pvp => pvp.type === type && pvp.prefix === prefix);
    if (preset) {
      regex = preset.regex;
    }
  }
  return regex;
}



// WEBPACK FOOTER //
// ./src/utils/validations/phone.js